import { useEffect, useState } from 'react';

/**
 * Server time now, corrected, ticking (§8.2).
 *
 * The **only** place in the console that reads a local clock, and it adds the
 * offset in the same expression. Everything downstream — the countdown, the MW
 * stage schedule in Phase 4 — takes the corrected instant as an argument and has
 * no way to reach `Date.now()` at all. A laptop 40 s fast is a support ticket
 * every session, and the defence that holds is structural rather than
 * remembered.
 *
 * Twice a second, because a countdown ticked at exactly 1 Hz visibly stutters
 * whenever the interval and the second boundary drift apart.
 */
export function useServerNow(offsetMs: number, intervalMs = 500): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return now + offsetMs;
}
